import { render } from "./tag_editor.vue?vue&type=template&id=f6b90760"
import script from "./tag_editor.vue?vue&type=script&lang=js"
export * from "./tag_editor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
var __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__